import React from 'react'
import { connect } from 'react-redux'
import { Form } from 'semantic-ui-react'
import forOwn from 'lodash/forOwn'
import { withConstantPermissions, withUserConfig } from 'shared'

import { convertUnicodeToLatin } from '../../../store/utility'
import containerForm, { formChangeContainer } from '../clientsContainerForm'
import { FirstPage, SecondPage, ThirdPage, FourthPage } from './Pages'
import clientsContainer from '../clientsContainer'
import { initialValues } from './constants'
import { loadCitiesByCountryId } from '../../../store/lookups'
import { actionTypes } from '../constants'

@(withConstantPermissions() as any)
@(clientsContainer as any)
@(containerForm as any)
@(formChangeContainer as any)
@withUserConfig(['MyCountryID'])
@(connect(undefined, {
  convertUnicodeToLatin,
  loadCitiesByCountryId,
}) as any)
class OrganizationClientForm extends React.Component<any> {
  cachedCities = new Map()

  componentDidMount() {
    forOwn(this.props.fields, ({ FName }) => {
      this.props.registerFormField(FName)
      if (['CityID', 'CityBusID'].includes(FName)) {
        const { cities } = this.props
        initialValues[FName] = cities[0].ID
      }
    })

    this.props.dynamicFields.forEach((df) => this.props.registerFormField(`DynFieldData.${df.FieldName}`))

    if (!this.props.editting) {
      const { dynamicFields, OpenDay } = this.props

      Object.keys(initialValues)
        .filter((key) => ['CountryID', 'CountryBusID'].includes(key))
        .forEach((key) => {
          initialValues[key] = this.props.MyCountryID
        })

      const allInitialValues = {
        ...initialValues,
        ORG_RegDate: OpenDay,
      }

      const finalInitialValues = dynamicFields.reduce((result, current) => {
        let defValue = current.DefaultValue

        if (current.FieldDataType === 0) {
          if (!defValue) defValue = 1
          defValue = parseInt(defValue, 10)
        }

        if (current.FieldDataType === 8) {
          const parentSelect = dynamicFields.find((dynamicField) => dynamicField.ID === current.ParentFieldID)
          if (parentSelect) {
            const filteredOptions = current.LookupData.filter(
              (cur) => cur.ParentID === parseInt(parentSelect.DefaultValue, 10),
            )

            defValue = filteredOptions[0] ? filteredOptions[0].ID : ''
          }
        }

        if (current.FieldDataType === 5 && current.DefaultValue === '01.01.1900') {
          defValue = ''
        }

        return {
          ...result,
          DynFieldData: {
            ...result.DynFieldData,
            [current.FieldName]: defValue,
          },
        }
      }, allInitialValues)

      // Redux form initialize method passed from reduxForm
      this.props.initialize(finalInitialValues)
    }
  }

  onTranslateAltRequest = (target) => async (event) => {
    const { value } = event.target

    if (!value) {
      this.props.changeFormValue(target, '')
      return
    }

    const result = await this.props.convertUnicodeToLatin(value)
    if (convertUnicodeToLatin.fulfilled.match(result)) {
      this.props.changeFormValue(target, result.payload)
    }
  }

  onCountryChange = async (value, fieldName) => {
    let cities
    const cachedKey = `${fieldName}_${value}`

    if (this.cachedCities.has(cachedKey)) {
      cities = this.cachedCities.get(cachedKey)
    } else {
      const {
        payload: { lookups: data },
      } = await this.props.loadCitiesByCountryId(value)
      cities = data

      this.cachedCities.set(cachedKey, data)
    }

    this.props.dispatch({ type: actionTypes.UPDATE_CITIES_LIST, payload: { cities, fieldName } })

    if (cities) {
      const [firstCity] = cities
      this.props.changeFormValue(fieldName, firstCity.ID)
    }
  }

  renderProperSection = () => {
    const { fields, selects, cityList, dynamicOptions, dynamicFields, dynamicFieldsDynamicOptions } = this.props

    switch (this.props.activeSection) {
      case 1:
        return (
          <FirstPage
            fields={fields}
            selects={selects}
            dynamicOptions={dynamicOptions}
            onTranslateAltRequest={this.onTranslateAltRequest}
          />
        )

      case 2:
        return (
          <SecondPage
            dynamicOptions={dynamicOptions}
            fields={fields}
            selects={selects}
            cityList={cityList}
            onTranslateAltRequest={this.onTranslateAltRequest}
            onCountryChange={this.onCountryChange}
          />
        )

      case 3:
        return <ThirdPage fields={fields} selects={selects} />

      case 4:
        return <FourthPage dynamicFields={dynamicFields} dynamicFieldsDynamicOptions={dynamicFieldsDynamicOptions} />

      default:
        return null
    }
  }

  render() {
    return <Form onSubmit={this.props.handleSubmit}>{this.renderProperSection()}</Form>
  }
}

export default OrganizationClientForm
